export const blockIconsSocialEngineering = (
	<span className='material-symbols-outlined'>engineering</span>
);
